import { createState } from '@/store/extensions/create';
import { updateState } from '@/store/extensions/update';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  ...createState,
  ...updateState,

  formModalOpened: false,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/index.js